import {createApi, fetchBaseQuery} from '@reduxjs/toolkit/query/react';
import {KEY_AUTHENTICATION_TOKEN} from '../../utils/constants/common';
import {env} from '../../utils/helpers/general';
import {getCookie} from '../../utils/helpers/cookie';

export const baseUrl = `${env(
  'REACT_APP_BOOKME_API_BASE_URL',
  'https://tracker-api.tpsportal.co.nz'
)}/api/`;

const api = createApi({
  baseQuery: fetchBaseQuery({
    baseUrl,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
    },
    prepareHeaders: headers => {
      const token = getCookie(KEY_AUTHENTICATION_TOKEN);
      if (token) {
        headers.set('authorization', `Bearer ${token}`);
      }
      return headers;
    },
    credentials: 'include',
  }),
  endpoints: () => ({}),
  tagTypes: [],
  reducerPath: 'bookmeapi',
});

export default api;
